import PropTypes from "prop-types";
import {
  Grid,
  Typography,
  IconButton,
  Tooltip,
  Card,
  CardHeader,
  CardMedia,
  CardContent,
  CardActions,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import ZoomOutMapIcon from "@material-ui/icons/ZoomOutMap";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import { CopyToClipboard } from "react-copy-to-clipboard";
import React from "react";
import { translate } from "react-i18next";
import { timeFormat, fileSizeFormat } from "../../utils/format";
import ModalImage from "../modalImage";
import { getThumbnaiImage, getDownloadUrl } from "../../utils/storage";

class FileDetail extends React.Component {
  static propTypes = {
    file: PropTypes.shape({
      key: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      url: PropTypes.string,
      download: PropTypes.string,
      thumbnail: PropTypes.string,
    }).isRequired,
    close: PropTypes.func,
    isDislay: PropTypes.bool,
  };
  constructor(props) {
    super(props);
    this.state = {
      openModal: false,
      copied: false,
    };
  }
  handleCloseClick = (event) => {
    if (event) {
      event.preventDefault();
    }
    this.props.close();
  };

  render() {
    const { file, t, isDisplay } = this.props;
    const { openModal, copied } = this.state;
    if (file && isDisplay) {
      return (
        <Grid container spacing={3} direction="column">
          {openModal && (
            <ModalImage
              image={file}
              handleClose={() => {
                this.setState({ openModal: !openModal });
              }}
            />
          )}

          <Grid item>
            <Card
              style={{
                maxWidth: 345,
              }}
            >
              <CardMedia
                style={{
                  height: 200,
                }}
                image={getThumbnaiImage(file.url)}
                children={
                  <Grid container justify="flex-end">
                    <IconButton
                      color="secondary"
                      onClick={this.handleCloseClick}
                    >
                      <CloseIcon />
                    </IconButton>
                  </Grid>
                }
              />
              <CardActions>
                <Tooltip title={t("view_detail")} placement="bottom">
                  <IconButton
                    onClick={() => {
                      this.setState({ openModal: !openModal });
                    }}
                    aria-label="view"
                  >
                    <ZoomOutMapIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip
                  title={copied ? t("copied") : t("copy_url")}
                  placement="bottom"
                >
                  <CopyToClipboard
                    text={file.url}
                    onCopy={() => {
                      const _this = this;
                      this.setState({ copied: true });
                      setTimeout(function () {
                        _this.setState({ copied: false });
                      }, 2000);
                    }}
                  >
                    <IconButton aria-label="view">
                      <FileCopyIcon />
                    </IconButton>
                  </CopyToClipboard>
                </Tooltip>
                <a href={file.download} target="_blank">
                  <Tooltip title={t("download")} placement="bottom">
                    <IconButton aria-label="download">
                      <CloudDownloadIcon />
                    </IconButton>
                  </Tooltip>
                </a>
              </CardActions>
              <CardContent>
                <Grid item>
                  <Grid container direction="column">
                    <Typography variant="subtitle2">{t("name")}</Typography>
                    <Typography>{file.key}</Typography>
                  </Grid>
                  <Grid container direction="column">
                    <Typography variant="subtitle2">{t("size")}</Typography>
                    <Typography>{fileSizeFormat(file.size)}</Typography>
                  </Grid>
                  <Grid container direction="column">
                    <Typography variant="subtitle2">
                      {t("created_at")}
                    </Typography>
                    <Typography>
                      {timeFormat({
                        time: file.createdAt,
                        format: "HH:mm:ss, DD/MM/YYYY",
                      })}
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      );
    } else {
      return "";
    }
  }
}

export default translate("translations")(FileDetail);
